module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isPreviousOrderCanceled && !_vm.isPreviousOrderExpired) ? _c('div', {
    staticClass: "vanguard-oops-button",
    domProps: {
      "innerHTML": _vm._s(_vm.localConfig !== null && _vm.localConfig.oopsButtonLabel || _vm.$t('all.defaultOopsButtonLabel'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }) : (_vm.isPreviousOrderCanceled) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.$t("form.orderCanceled")))]) : (_vm.isPreviousOrderExpired) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t("all.expiredMessage")))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e86a4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/oops-button.vue
// module id = 860
// module chunks = 0 1